import AbstractPiniaModel from '../models/AbstractPiniaModel'
import { useSubscriptionModelsStore } from '../pinia/stores/subscriptionModels'

export class SubscriptionModel extends AbstractPiniaModel {
    //#region Instance Code
        constructor(subscription) { super( subscription ) }

        id()                    { return Number(this.source.id) }
        type()                  { return this.source.typ }
        durationInMonths ()     { return Number(this.source.laufzeit) }
        extensionPeriodInDays() { return Number(this.source.ablaufperiode) }
        cost()                  { return Number(this.source.preis) / 100 }
        name()                  { return this.source.name }
        description()           { return this.source.beschreibung }
    //#endregion Instance Code


    //#region Static Methods
        static piniaStore() {
            return useSubscriptionModelsStore()
        }

        static create(subscriptionModelSource) { return new SubscriptionModel(subscriptionModelSource) }

        static getCurrent()         { return this.create(this.piniaStore().currentSubscriptionModel) }
        static getForID(id)         { return this.create(this.piniaStore().subscriptionModelWithID(id)) }
        static getForExtensions()   { return this.create(this.piniaStore().extensionSubscriptionModel) }

        static setCurrentByID(id)           { return this.dispatch('setCurrentSubscriptionModelByID', id) }
        static setAll(subscriptionModels)   { this.dispatch('setAllSubscriptionModels', subscriptionModels.map(s=>s.getSource())) }
    //#endregion Static Methods
}
